import styled from 'styled-components';
const SearchGroupStyled = styled.div`
  border-radius: 12px;
  background-color: #fff;
  .MuiCardContent-root {
    border-radius: 12px;
  }
  .line {
    display: flex;
    gap: 48px;
    > div {
      flex: 1;
    }
  }
  /* .css-1q60rmi-MuiAutocomplete-endAdornment {
    display: flex;
    .MuiIconButton-root {
      width: 16px;
      height: 16px;
    }
    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
  } */
  .card-content {
    padding: 32px;
    display: flex;
    /* align-items: center; */
    .left {
      flex-grow: 1;
    }

    .button-group {
      height: 100%;
      margin-left: 40px;
      display: flex;
      flex-direction: row;
      /* justify-content: space-between; */
      /* align-items: center; */
      .reset {
        /* margin-bottom: 24px; */
        margin-right: 24px;
      }
      .search {
        margin-right: 0;
      }
    }
  }

  .MuiTextField-root {
    /* width: 400px; */
    /* height: 56px; */
  }
`;
export default SearchGroupStyled;
